const Switch = {
  defaultProps: {
    colorScheme: "secondary",
  },
};

export default Switch;
